import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
@Component({
  selector: "app-payment-page-dialog",
  template: `
    <div mat-dialog-content id="paymentDialog" style="max-height: 85vh !important;overflow:auto" >
      <iframe [src]="checkoutUrl" id="webApptiFrame" height="800" width="450"></iframe>
    </div>
  `,
})
export class PaymentPageDialogComponent {
  constructor(public dialogRef: MatDialogRef<PaymentPageDialogComponent>,private sanitizer: DomSanitizer

            ) {
              dialogRef.disableClose = true; 
              this.checkoutUrl=this.sanitizer.bypassSecurityTrustResourceUrl(this.checkoutUrl); 
            }

  checkoutUrl: any;

  close() {
    this.dialogRef.close();
  }

  cancelRequest() {
    window.location.reload();
  }
 
}
